import React from "react";

import { stypes } from "../../common/common";

const CarDetailHeader = ({ stype }) => {
	const handleClick = (id) => {
		const target = document.getElementById(id);
		target?.scrollIntoView({ behavior: "smooth" });
	};

	return (
		<div className="header-car">
			<div className="m-container">
				<p onClick={() => handleClick("outsfeatures")}>Đặc điểm</p>
				{stype === stypes.SD && (
					<>
						<p onClick={() => handleClick("papers")}>Giấy tờ thuê xe</p>
						<p onClick={() => handleClick("carmap")}>Vị trí xe</p>
					</>
				)}
				<p onClick={() => handleClick("owner")}>Chủ xe</p>
			</div>
		</div>
	);
};

export default CarDetailHeader;
